import './theme/theme.css';

import { formKitPlugin } from './plugins';
import { createVfm } from 'vue-final-modal';

export const createZightTheme = async () => {
  return Promise.resolve({
    install(app: any) {
      app.use(formKitPlugin[0], formKitPlugin[1]);
      app.use(createVfm());
    },
  });
};
